import { signInLinkAndText, submitPublicSupportCaseTextAndLink } from './constants';

export const accountExistsMessage = `${signInLinkAndText} to your Avalara account to continue. Keep seeing this message? ${submitPublicSupportCaseTextAndLink}.`;
export const accountExistsTitle = 'Account already exists.';
export const emailExistsMessage = (productName: string, isFreeTrial?: boolean | undefined, signInUrl?: string) => {
  const signInLink = signInUrl ? `<a href="${signInUrl}">Sign in</a>` : signInLinkAndText;
  return isFreeTrial
    ? `${productName} is available only to new accounts. ${signInLink} to Avalara`
    : `We found another account that uses this email. ${signInLink} to Avalara to buy ${productName}.`;
};

type FormatAccountSetupErrorProps = {
  isFreeTrial?: boolean;
  passwordRedirectUrl?: string;
  productName: string;
  redirectUrl: string;
  resultMessage: string;
  signInUrl?: string;
};

export const formatAccountSetupError = ({
  isFreeTrial,
  resultMessage,
  redirectUrl,
  productName,
  passwordRedirectUrl = '',
  signInUrl,
}: FormatAccountSetupErrorProps) => {
  let html = '';
  let message = '';
  let title = 'Sorry, something went wrong';
  let locationAfterErrorDismissal = '';
  if (/email already exists/.test(resultMessage) || /User .* already exist/.test(resultMessage)) {
    html = emailExistsMessage(productName, isFreeTrial, signInUrl);
    title = accountExistsTitle;
    locationAfterErrorDismissal = redirectUrl;
  } else if (/account already exists/i.test(resultMessage)) {
    html = accountExistsMessage;
    title = accountExistsTitle;
    locationAfterErrorDismissal = redirectUrl;
  } else if (/common password/.test(resultMessage)) {
    message = 'Strong passwords avoid common words or phrases.';
    title = 'Try a different password';
    locationAfterErrorDismissal = passwordRedirectUrl;
  } else if (/length requirements/.test(resultMessage)) {
    message = 'Long passwords are more secure than short ones.';
    title = 'Try a longer password';
    locationAfterErrorDismissal = passwordRedirectUrl;
  } else if (/complexity requirements/.test(resultMessage)) {
    message = 'Use numbers, symbols, and a mix of uppercase and lowercase letters.';
    title = 'Password too simple';
    locationAfterErrorDismissal = passwordRedirectUrl;
  } else if (/ESB Signup key is invalid/.test(resultMessage)) {
    message =
      'There was a problem creating your account. Go to your e-commerce platform and try setting up your account again.';
    html = `Keep seeing this message? ${submitPublicSupportCaseTextAndLink}`;
    locationAfterErrorDismissal = redirectUrl;
  } else if (/Signup key is invalid/.test(resultMessage)) {
    message =
      'There was a problem creating your account. Go to your BigCommerce store and try setting up your account again.';
    html = `Keep seeing this message? ${submitPublicSupportCaseTextAndLink}`;
  }

  return { html, message, title, locationAfterErrorDismissal };
};
